import { Component, input, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "app-page-title",
  templateUrl: "./page-title.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PageTitleComponent {
  readonly content = input("");

  constructor() {}
}
